import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { CookiePolicy } from '../../Models/Models/PrivacyPolicy/CookiePolicy';

declare var IS_RUNNING_IN_APP_POOL;

export class UserCookieClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(): Promise<CookiePolicy, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/PrivacyPolicy/UserCookie/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = {}

    return AjaxWrapper.get<CookiePolicy, any>(url, data);
  }
  public post(enabled: boolean): Promise<boolean, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/PrivacyPolicy/UserCookie/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { enabled: enabled }

    return AjaxWrapper.post<boolean, any>(url, data);
  }
}

